import React from 'react';
import PartnerSelect from '../../Partners/PartnerSelect';

const EditableSubstitutePartnerCell = ({ unitId, defaultPartners, disabledPartnerId, validationMessage }) => (
  <PartnerSelect
    name={['substitute_partner_id', unitId]}
    defaultPartners={defaultPartners}
    disabledOption={disabledPartnerId}
    required
    validationMessage={validationMessage}
    size="small"
    className="client-inform-inline-field"
  />
);

export default EditableSubstitutePartnerCell;
